import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { WapiService } from 'wanderu-service-wapi';

import { actions } from './base';

const logger = Logger.getLogger('wanderu-ducks-account');

function check(referralCode) {
    return async (dispatch) => {
        dispatch(actions.startWork(referralCode));

        let error;
        let meta = {};
        try {
            await WapiService.get(`referralcheck.json?referralCode=${referralCode}`);
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('checkReferralCode', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };

            return;
        } finally {
            dispatch(actions.endWork(referralCode, meta, error));
        }
    };
}

export {
    check,
};
